import StickyContent from '../components/sticky-content';

export default {
  init() {
    const stickyElement = document.querySelector('.c-single__overview-wrapper');
    new StickyContent({
      element: stickyElement,
      section: '.c-single',
      debugId: 'sticky bg',
    });
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/single.js